import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button } from 'antd';
import { useAppStore } from '../../stores';
import { RenewalSuggestionsList } from '..';
import './RenewalSuggestionsModal.less';

const RenewalSuggestionsModal: React.FC = () => {
    const { renewalSuggestionsStore } = useAppStore();

    const onClose = () => {
        renewalSuggestionsStore.setModalVisible(false);
        renewalSuggestionsStore.disableRenewalSuggestionsSearch();
    };

    const onSubmit = () => {
        renewalSuggestionsStore.applySelectedSuggestions();
        onClose();
    };

    return (
        <Modal
            className="contract-ingestion-renewal-suggestions-modal"
            title="Renew Business"
            visible={renewalSuggestionsStore.modalVisible}
            maskClosable={false}
            closable={false}
            width={1200}
            destroyOnClose
            centered
            onCancel={onClose}
            footer={[
                <Button key="cancel-button" className="light alpha-dialog-button" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="save-button" type="primary" onClick={onSubmit}>
                    Continue
                </Button>
            ]}
        >
            <div className="renewal-suggestions-explanation-container">
                <span className="explanation-title">Existing Business Detected!</span>
                <span className="explanation-text">
                    It appears that the document you uploaded already exists as a business. Do you want to renew this
                    business?
                </span>
            </div>

            <RenewalSuggestionsList />
        </Modal>
    );
};

export default observer(RenewalSuggestionsModal);
